module.exports = __webpack_public_path__ + "img/logo_sc.09feda1f.png";